module.exports = __webpack_public_path__ + "img/gambia.70900f1.webp";